/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Grid from '@mui/material/Grid2';
import { alpha } from '@mui/material/styles';
import { Avatar, Box, Card, colors, Link, Stack, Typography, useMediaQuery, useTheme} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GavelIcon from '@mui/icons-material/Gavel';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import SupportIcon from '@mui/icons-material/Support';


const FeaturedServices = (): JSX.Element => {

  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  const services = [
    {
      color: colors.blue[500],
      title: 'Browse Candidates',
      link: '/Filers',
      links: [
        {
          title: 'Filer Listings',
          href: '/Filers/FilerListing',
        },
        {
          title: 'Filer Types & Filing Schedules',
          href: '/Filers/FilerTypes',
        }
      ],
      icon: (
        <PersonOutlineIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.orange[500],
      title: 'Explore the Data',
      link: '/Data/SearchItems',
      links: [
        {
          title: 'Search Data',
          href: '/Data/SearchItems',
        },
        {
          title: 'OCPF Data Center',
          href: '/Data',
        }
      ],
      icon: (
        <AttachMoneyIcon fontSize={isSM?'small': 'large'}/>
      ),
    },
    {
      color: colors.teal[500],
      title: 'Recent Activities',
      link: '/Reports/log',
      links: [
        {
          title: 'Real-time Report Filings',
          href: '/Reports/log',
        },
        {
          title: 'Recently Organized Committees',
          href: '/Filers/RecentlyOrganized',
        }
      ],
      icon: (
        <AccountBalanceIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.red[500],
      title: 'Laws & Regulations',
      link: '/Legal',
      links: [
        {
          title: 'Legal Resources',
          href: '/legal',
        },
        {
          title: 'Contribution Limits Chart',
          href: '/Legal/ContributionLimits',
        },
        {
          title: 'Pay Civil Penalty or Forfeiture',
          href: 'https://www.ncourt.com/x-press/X-onlinepayments.aspx?Juris=31c943a9-97cd-416f-bf50-8a0634242629',
        }
      ],
      icon: (
        <GavelIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.green[500],
      title: 'Organize With OCPF',
      link: '/Filers/GettingStarted',
      links: [
        {
          title: 'Step-by-Step Instructions',
          href: '/Filers/GettingStarted',
        },
        {
          title: 'Set Up Depository Bank',
          href: '/Filers/BankDepository',
        }
      ],
      icon: (
        <EventNoteIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.indigo[500],
      title: 'Forms & Education',
      link: '/Publications',
      links: [
        {
          title: 'Organization Forms',
          href: '/Publications',
        },
        {
          title: 'Help Videos',
          href: '/Publications/Videos',
        }
      ],
      icon: (
        <PictureAsPdfIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.amber[500],
      title: 'Reports by Office',
      link: '/Reports/',
      links: [
        {
          title: 'Browse All Reports',
          href: '/Reports',
        },
        {
          title: 'Mayoral Races',
          href: '/Reports/MayoralReports',
        }
      ],
      icon: (
        <BackupTableIcon fontSize={isSM?'small': 'large'} />
      ),
    },
    {
      color: colors.deepPurple[500],
      title: 'Clerk Support',
      link: '/Municipal',
      links: [
        {
          title: 'Local Filers How-to Guides',
          href: '/Municipal',
        },
        {
          title: 'Election Schedule Calculator',
          href: '/Municipal#election-calculator',
        }
      ],
      icon: (
        <SupportIcon fontSize={isSM?'small': 'large'} />
      ),
    },
  
  ];


  const displayPublicationTile = () => {

    return (
      <Stack direction={"column"} spacing={1}>
        <Link href={'/Publications'}>
          <Typography variant={'body2'} fontWeight={isSM?550:550} color={'primary.ocpfBlue'} display={'flex'} justifyContent={'center'}>
            Organization Forms
          </Typography>
        </Link>
        <Stack direction="row" spacing={1}>
          <Link href={'/Publications/FactSheets'}>
            <Typography variant={'body2'} fontWeight={isSM?550:550} color={'primary.ocpfBlue'} display={'flex'} justifyContent={'center'}>
              Guides
            </Typography>
          </Link>
          <Link href={'/Publications/Videos'}>
            <Typography variant={'body2'} fontWeight={isSM?550:550} color={'primary.ocpfBlue'} display={'flex'} justifyContent={'center'}>
              Help Videos
            </Typography>
          </Link>
        </Stack>
      </Stack>
    )

  }
  
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          variant="h4"
          align={'center'}
          data-aos={'fade-up'}
          gutterBottom
          fontWeight={700}
        >
          Featured Resources
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={4}>
          {services.map((item, i) => (
            <Grid key={i} size={{ xs: 12, sm: 6, md: 3 }}>
              <Box
                display={'block'}
                onClick={() => {
                  window.location.href = item.link;
                }}
                className={'is-clickable'}
                width={1}
                height={1}
                sx={{
                  textDecoration: 'none',
                  transition: 'all .2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box
                  component={Card}
                  padding={2}
                  width={1}
                  height={1}
                  data-aos={'fade-up'}
                  data-aos-delay={i * 100}
                  data-aos-offset={100}
                  data-aos-duration={600}
                >
                  <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                    <Box
                        component={Avatar}
                        width={isSM?25:40}
                        height={isSM?25:40}
                        marginBottom={isSM?1:2}
                        bgcolor={alpha(item.color, 0.1)}
                        color={item.color}
                        variant={'rounded'}
                        borderRadius={2}
                      >
                        {item.icon}
                      </Box>
                    <Typography
                      variant={'h6'}
                      gutterBottom
                      sx={{ fontWeight: 600 }}
                    >
                      {item.title}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box marginTop={1}>
                      {
                        item.title === 'Forms & Education' ?
                        displayPublicationTile():
                        <Stack direction={'column'} spacing={1}>
                          {
                            item.links.map((link, i) => (
                                  <Link key={i} href={link.href}>
                                    <Typography variant={'body2'} fontWeight={isSM?550:550} color={'primary.ocpfBlue'} display={'flex'} justifyContent={'center'}>
                                      {link.title}
                                    </Typography>
                                  </Link>
                              ))
                          }
                        </Stack>
                      }
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FeaturedServices;
